import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import { Box, IconButton } from "@mui/material";
import { format } from "date-fns";
import { t } from "i18next";
import BaseTable from "../../../../components/table/BaseTable";
import { useDialogBetter } from "../../../../hooks/useDialogBetter";
import { useGetTasks } from "../../../../services/taskService";
import { FinalizeTaskDialog } from "../../../TaskPage/FinalizeTaskDialog";
import { EditTaskDialog } from "../../../TaskPage/EditTaskDialog";
import EditIcon from "@mui/icons-material/Edit";

const HEADERS = [
    t("clients.ClientPassportTasksTable.name"),
    t("clients.ClientPassportTasksTable.way"),
    t("clients.ClientPassportTasksTable.startDate"),
    t("clients.ClientPassportTasksTable.priority"),
    t("clients.ClientPassportTasksTable.subject"),
    t("clients.ClientPassportTasksTable.status"),
    t("clients.ClientPassportTasksTable.creator"),
    t("clients.ClientPassportTasksTable.finalize"),
    ""
];

export function ClientPassportTasksTable(props) {
    const { openDialog: openFinalizeTaskDialog } = useDialogBetter();
    const {openDialog : openEditTaskDialog } = useDialogBetter();

    const searchParams = props.relatedTasksForClientId
        ? new URLSearchParams({
              related_tasks_for_client_id: props.relatedTasksForClientId,
          })
        : props.customerId
          ? new URLSearchParams({ customer_id: props.customerId })
          : new URLSearchParams({});

    if (props.investmentId) {
        searchParams.set("investment", props.investmentId);
    }

    const { data: customerTasks, isLoading, refetch } = useGetTasks(searchParams, {
        select: (data) => {
            return data.map((task) => ({
                rowId: task.id,
                data: [
                    task.name,
                    t(`tasks.ways.${task.way}`),
                    task.start ? format(new Date(task.start), "yyyy-MM-dd HH:mm") : "",
                    t(`tasks.priorities.${task.priority}`),
                    t(`tasks.subjects.${task.subject.name_eng}`),
                    t(`tasks.statuses.${task.status.status_name_eng}`),
                    task.seller ? task.seller.full_name : t("unknown"),
                    <IconButton
                        color="success"
                        onClick={(e) => {
                            e.stopPropagation();
                            openFinalizeTaskDialog({
                                Component: FinalizeTaskDialog,
                                onCloseFn: refetch,
                                componentProps: {
                                    task: task,
                                },
                            });
                        }}
                        size="small"
                        disabled={task.status.status_name_eng === "Finalized"}
                    >
                        <CheckCircleOutlineIcon fontSize="small" />
                    </IconButton>,
                    <IconButton
                        color="primary"
                        onClick={(e) => {
                            e.stopPropagation();
                            openEditTaskDialog({
                                Component: EditTaskDialog,
                                onCloseFn: refetch,
                                componentProps: {
                                    task: task,
                                },
                            });
                        }}
                        size="small"
                        disabled={task.status.status_name_eng === "Finalized"}
                    >
                        <EditIcon fontSize="small" />
                    </IconButton>
                ],
            }));
        },
    });
    return (
        <Box sx={{ maxHeight: props.maxHeight || 200, overflow: "auto", borderRadius: 1 }}>
            <BaseTable
                stickyHeader={true}
                headers={HEADERS}
                rows={customerTasks}
                showEditButton={false}
                showDeleteButton={false}
                sortable={false}
                hiddenColumns={[]}
                selectedRows={[]}
                colMaxLength={props.colMaxLength}
                showLoader={isLoading}
            />
        </Box>
    );
}
